'use strict';

angular.module('postController', [])

.controller('PostController', ['$scope', '$rootScope', '$log', '$q','$routeParams', '$sce', 'PostService', 'CommonService',
    function ($scope, $rootScope, $log, $q, $routeParams, $sce, PostService, CommonService) {    
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , name = currentUser.name
    , today = moment().unix()
    ;
    $scope.showTAC = false;
    $scope.newPost = {};
    $scope.showCreatePostForm = false;
    $scope.posts =[];
    $scope.showBeforePostId = 0;
    $scope.filter = {};
    $scope.filter.filterType = 'propertyRelated';
    $scope.pagesize = 5;
    $scope.images = [];

    $rootScope.header.show = false;
    $scope.page = 'posts';

    $scope.init = function() {
        $scope.loadPosts();
        $scope.initNewPost();
    }

    $scope.filterPost = function(filter, post) {
        // $scope.showMyPost = false;
        // $scope.showAllPost = false;
        // $scope.showOrganizationPost = false;
        // $scope.showPendingPost = false;
        $scope.filter.filterType = filter;
        $scope.filter.data = post;
        // switch(filter) {
        //     case 'currentListing':
        //         break;
        //     case 'pending':
        //         $scope.showPendingPost= true;
        //         break;
        //     case 'personal':
        //         $scope.showMyPost = true;
        //         break;
        //     case 'organization':
        //         $scope.showOrganizationPost = true;
        //         break;
        //     case 'morefromme':
        //         //sets all filter to false
        //         break;
        //     case 'all':
        //     default:
        //         $scope.showAllPost = true;
        //     break;
        // }
        $scope.loadPosts();
    }

    var getPosts = function() {
        $rootScope.loading = true;
        PostService.getPosts($scope.filter, $scope.pagesize, $scope.showBeforePostId).then(function(response) {
            var i=0;
            if(response.length > 0) {
                // $scope.page = $scope.page + 1;
                 angular.forEach(response, function(rs) {

                    try{
                        $scope.showBeforePostId = rs.id;
                        rs.data = JSON.parse(rs.data);
                        rs.data.htmlMessage = $sce.trustAsHtml(rs.data.message);
                        rs.data.videoUrlFull = '';
                        if(rs.data.videoUrl !==undefined && rs.data.videoUrl!='') {
                            rs.data.videoUrlFull = 'http://www.youtube.com/embed/' + rs.data.videoUrl;
                            rs.data.videoUrlFull = $sce.trustAsResourceUrl(rs.data.videoUrlFull);
                        }

                        var wiseberryUrl = 'http://www.wiseberry.com.au';
                        rs.popUpPropetyTags = {'title':'', 'content': ''};
                        var tmpHTML = [];
                        angular.forEach(rs.data.tags.propertyTags, function(property){
                            tmpHTML.push(
                                '<a target="_blank" href="' + wiseberryUrl + '/listing/' + property.propertyRef + '">' +
                                property.streetRef + ' ' + ((property.streetName.length > 11 )? property.streetName.substring(0, 11) + '...' : property.streetName) + ' ' + property.streetType + '<a>'
                            );
                        });
                        angular.forEach(rs.data.tags.rentalPropertyTags, function(property){
                            tmpHTML.push(
                                '<a target="_blank" href="' + wiseberryUrl + '/listing/' + property.propertyRef + '">' +
                                property.streetRef + ' ' + ((property.streetName.length > 11 )? property.streetName.substring(0, 11) + '...' : property.streetName) + ' ' + property.streetType + '<a>'
                            );
                        });
                        if(tmpHTML.length > 0) {
                            rs.popUpPropetyTags.content = tmpHTML.join(', ');
                        }

                        rs.popUpSuburbTags = {'title':'', 'content': ''};
                        var tmpHTML = [];
                        angular.forEach(rs.data.tags.suburbTags, function(suburb) {
                            var slugSuburb = suburb.region.toLowerCase().replace(/ /g,'-');
                            slugSuburb = slugSuburb.replace(/\//g,'-');
                            tmpHTML.push('<a target="_blank" href="' + wiseberryUrl + '/buy/region/' + 
                                slugSuburb + '/suburb/' +
                                suburb.name.toLowerCase().replace(/ /g,'-') + '">' + suburb.name +'<a>');
                        });
                        if(tmpHTML.length > 0) {
                            rs.popUpSuburbTags.content = tmpHTML.join(', ');
                        }

                        rs.popUpPeopleTags = {'title': '', 'content': ''};
                         var tmpHTML = [];
                        angular.forEach(rs.data.tags.peopleTags, function(person) {
                            var tmpName = person.nameFirst + ' ' + person.nameLast;
                            if (person.name) {
                                tmpName = person.name;
                            }
                            tmpHTML.push('<a target="_blank" href="' + wiseberryUrl + '/' + person.identifier + '/team/member/' +
                                tmpName.toLowerCase().replace(/ /g,'-') + '/' + (person.id*12569) + '">' + tmpName +'<a>');
                        });
                        if(tmpHTML.length > 0) {
                            rs.popUpPeopleTags.content = tmpHTML.join(', ');
                        }

                        

                    }catch(e){
                        console.log(e);
                        rs.data = {};
                    }
                    rs.ref = rs.id * 12569;
                    $scope.posts.push(rs);
                    i++;
                });
            }
        }).finally( function(){
            $rootScope.loading = false;
            $scope.view = 'list';
        });
    }

    

    $scope.loadPosts = function() {
        $scope.posts = [];
        $scope.showBeforePostId = 0;
        getPosts();
    }

    $scope.loadMorePost = function() {
        if ($rootScope.loading) {
            return;
        }
        getPosts();
    }

    $scope.showCreateNewPost = function() {
        $scope.initNewPost();
        $scope.showCreatePostForm = true;
    }

    
    $scope.hideCreateNewPost = function() {
        $scope.showCreatePostForm = false;
    };


    var clearTags = function() {
      $scope.taggedProperties = [];
      $scope.taggedRentalProperties = [];
      $scope.taggedSuburbs = [];
      $scope.taggedPeople = [];
    }

    $scope.initNewPost = function() {
        // currentEditPost = null;
        // clearTags();
        $scope.images = [];
        angular.element("#fileToUpload").val(null);
        $scope.newPost= getNewPost();
    }

    var getNewPost = function() {
        var newPost = {
            id: 0,
            message: '',
            imgUrls: [],
            videoUrl: '',
            postType: 3,
            tags: {
                propertyTags: [],
                suburbTags: [],
                peopleTags: []
            }
        };
        return newPost;
    }

    // $scope.savePost = function(item) {
    //     if(item.id > 0) {
    //        updatePost(item);
    //     } else {
    //        saveNewPost(item);
    //     }
    // }

    //cancel new post creation
    $scope.cancelNewPost = function() {
        // currentEditPost = null;
        $scope.initNewPost();
        $scope.hideCreateNewPost();
    }

    $scope.saveNewPost = function() {
        item = $scope.newPost;
        if (item.message.trim() == '' && item.videoUrl.trim() == '' && $scope.images.length == 0) {
            alert('Nothing to post, please write something to post');
            return ;
        }
        
        $rootScope.loading = true;
        item.tags = setTagsForSave();
        if ($scope.images.length > 0) {

            // $scope.uploadingImg = true;
            CommonService.fixExifRotation($scope.images).then(function(images){
                return PostService.uploadFiles(images, $scope);
            })
            .then(function(imgUrls) {
                // $rootScope.loading = true;
                // $scope.uploadingImg = false;
                item.imgUrls = imgUrls;
                return item;
            })
            .then(PostService.saveNewPost)
            .then(function(postId){
                item.id = postId;
                return PostService.sendPostApproveRequestEmail(item);
            })
            .then(function(response){
                PostService.sendPostEmailToSeller();
            })
            .then(function(response){
                $scope.filterPost('propertyRelated');
            }).catch(function(err){
                // $rootScope.loading = false;
                console.log(err);
            }).finally(function() {
                // $scope.uploadingImg = false;
                $rootScope.loading = false;
                $scope.initNewPost();
                $scope.hideCreateNewPost();
            });  
        } else {
            PostService.saveNewPost(item)
                .then(function(postId){
                    item.id = postId;
                   return PostService.sendPostApproveRequestEmail(item);               
                })
                .then(function(response){
                    PostService.sendPostEmailToSeller();
                })
                .then(function(response) {
                    $scope.filterPost('propertyRelated');
                }).catch(function(err) {
                    // $rootScope.loading = false;
                    console.log(err);
                }).finally(function() {
                    $rootScope.loading = false;
                    $scope.initNewPost();
                    $scope.hideCreateNewPost();
                });
        }
                  
    }

    var setTagsForSave = function() {
        var propertyTags  = [];
        var rentalPropertyTags = [];
        var suburbTags = [];
        var peopleTags = [];

        var property = $rootScope.currentListing;
        propertyTags.push({
            propertyRef: property.propertyRef, 
            streetUnit: property.streetUnit,  
            streetRef: property.streetRef, 
            streetName: property.streetName,  
            streetType: property.streetType,
            agentRef: property.agentRef,
            propertyImage: property.image
        });
        

        var tags = {
            propertyTags: propertyTags,
            suburbTags: suburbTags,
            peopleTags: peopleTags,
            rentalPropertyTags: rentalPropertyTags,
        };


        return tags;
    }


    $scope.init();


}]);